<template>
	<main class="client-connect">
		<router-view v-if="hasAccessToClientConnect()" />
		<AccessDenied v-else :item="'Client Connect'" />
	</main>
</template>

<script>
import { isEmpty } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';

import AccessDenied from '../../components/global/AccessDenied.vue';

export default {
	name: 'ClientConnectV2Home',
	components: {
		AccessDenied,
	},
	computed: {
		...mapState({
			types: (state) => state.clientConnectV2.alerts.types.data,
			statuses: (state) => state.clientConnectV2.alerts.statuses.data,
		}),
	},
	methods: {
		...mapActions([
			'resetClientConnectAlerts',
			'resetClientConnectLeads',
			'getAlertTypes',
			'getAlertStatuses',
		]),
		...mapGetters(['hasAccessToClientConnect']),
	},
	async created() {
		if (isEmpty(this.statuses)) {
			await this.getAlertStatuses();
		}
		if (isEmpty(this.types)) {
			await this.getAlertTypes();
		}
	},
	beforeDestroy() {
		this.resetClientConnectAlerts(true);
		this.resetClientConnectLeads();
	},
};
</script>

<style lang="scss" scoped>
.client-connect {
	@include rem(padding, 20px 30px);

	@media screen and (max-width: 600px) {
		@include rem('padding', 15px);
	}

	& /deep/ .page-title {
		@include rem('margin-bottom', 20px);
		@include rem('margin-top', 0);
	}
}
</style>
